import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextField,
  Grid,
} from "@mui/material";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getPropertieObjectById } from "../helper";
import OnblurComponent from "../onBlur";

export default class DynamicList {
  static DisplayTab(props) {
    const { onChange, onCheckChange, onPropertieChange, state, error } = props;
    const columns = getUnitPropertie(state, "columns") || 4;
    const label = getUnitPropertie(state, "label");
    const required = getUnitPropertie(state, "required");
    const readOnly = getUnitPropertie(state, "readOnly");
    const hidden = getUnitPropertie(state, "hidden");
    const isRequired = getUnitPropertie(state, "isRequired");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            select
            label={language.maximumItemsInList}
            name="columns"
            onChange={(event) => onPropertieChange(event)}
            value={columns}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
            <MenuItem value="3">3</MenuItem>
            <MenuItem value="4">4</MenuItem>
          </TextField>
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  onChange={(event) => onCheckChange(event)}
                  value={hidden}
                  checked={hidden || false}
                />
              }
              label={language.propertieHidden}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onChange,
      onPropertieChange,
      state,
      error,
      onCheckChange,
      handleDefaultValueChange,
      addRowDefaultValue,
      deleteDefaultValueRow,
      setObjeto,
    } = props;

    const regex = getUnitPropertie(state, "regex");
    const messageRegex = getUnitPropertie(state, "messageRegex");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="value"
            variant="outlined"
            id="value"
            label={language.propertieDefaultValue}
            value={state.value || ""}
            fullWidth
            helperText={language.toolTipDefaultValue}
          />
        </Grid>
        <OnblurComponent {...props} />
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="regex"
            variant="outlined"
            id="regex"
            label={language.propertieRegex}
            value={regex || ""}
            fullWidth
            helperText={language.toolTipRegex}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="messageRegex"
            variant="outlined"
            id="messageRegex"
            label={language.propertieRegexMessage}
            value={messageRegex || ""}
            error={!!getPropertieObjectById(error, "messageRegex")}
            fullWidth
            helperText={language.toolTipRegexMessage}
          />
          {error && getPropertieObjectById(error, "messageRegex") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
